import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M18.389 18.387c-2.934 2.934-7.279 3.568-10.834 1.924-.525-.211-.955-.382-1.364-.382-1.14.007-2.558 1.112-3.295.375s.369-2.156.369-3.302c0-.41-.164-.832-.376-1.358-1.645-3.555-1.01-7.9 1.924-10.834 3.745-3.747 9.83-3.747 13.576 0 3.752 3.752 3.745 9.831 0 13.577",
      "clip-rule": "evenodd",
      style: {"stroke":"inherit"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M15.382 11.997h.009M11.533 11.997h.01M7.685 11.997h.009",
      style: {"stroke":"inherit"}
    }, null, -1)
  ])))
}
export default { render: render }